export const COLOR_DEFAULT = '#5096db';
export const COLOR_ERROR = '#FF0000';
export const COLOR_IN_PROGRESS = '#3FA6FF';
export const COLOR_IN_PROGRESS_FILL = '#DCF2FF';
export const COLOR_IDLE = '#CCCCCC';
export const COLOR_IDLE_FILL = '#F5F5F5';
export const COLOR_COMPLETED = '#00BA7C';
export const COLOR_COMPLETED_FILL = '#D6FFE6';
